module.exports = __webpack_public_path__ + "img/notification-1.75deb7a2.svg";